import { render, staticRenderFns } from "./gift_list.vue?vue&type=template&id=4d2b629a&scoped=true"
import script from "./gift_list.vue?vue&type=script&lang=js"
export * from "./gift_list.vue?vue&type=script&lang=js"
import style0 from "./gift_list.vue?vue&type=style&index=0&id=4d2b629a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2b629a",
  null
  
)

export default component.exports